export const boundaryNumber = 10000;
export const heightToWidthVideoRatio = 1.77777;
